import React, { useState } from "react";
import { func, object } from "prop-types";
import { sendOtp } from "@quintype/bridgekeeper-js";

import { isValidEmail } from "../../utils";
import "./forms.m.css";

export function ForgotPassword({ setActiveTab, userInfo, setUserInfo, setLoading }) {
  const [error, setError] = useState("");

  const trackForgotPwdEvent = (action, error = "") => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push(
        error
          ? {
              event: "dl_forgotpwd_steps",
              event_action: action,
              error_message: error,
            }
          : {
              event: "dl_forgotpwd_steps",
              event_action: action,
            }
      );
    }
  };

  const setEmailData = (e) => {
    const userObj = { ...userInfo };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUserInfo(userObj);
  };

  const emailHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userInfo.email) {
      setError("Email id required !");
      trackForgotPwdEvent("email_submit", error);
      return;
    }

    if (!isValidEmail(userInfo.email)) {
      setError("Please enter a valid email address");
      return;
    }
    trackForgotPwdEvent("email_submit");
    setLoading(true);
    const data = { email: userInfo.email };

    try {
      const { message, error, status } = await sendOtp(data);

      if (status === 200) {
        setActiveTab("reset-password");
      } else {
        setError("Error sending OTP");
        console.error("Error sending OTP", error, message);
        trackForgotPwdEvent("otp_not_recieved", error);
      }
    } catch (error) {
      setError("Error sending OTP");
      console.error("Error sending OTP", error);
      trackForgotPwdEvent("otp_not_recieved", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div styleName="auth-container forgotPasswordContainer">
      <h2 styleName="auth-title">Forgot Password</h2>
      <p styleName="description">
        Enter the email address associated with your account, and we'll send you an OTP to reset your password.
      </p>

      <form onSubmit={emailHandler} styleName="form">
        <label htmlFor="email" styleName="auth-label">
          Enter Email
        </label>
        <input
          type="email"
          id="email"
          name="Email"
          value={userInfo.email}
          onChange={setEmailData}
          placeholder="Enter your email"
          onFocus={() => setError("")}
          required
          styleName="auth-input"
        />
        {error ? <p styleName="error">{error}</p> : null}
        <button type="submit" styleName="submit-button" onClick={emailHandler}>
          Continue
        </button>
      </form>

      <a href="#" styleName="goBack" onClick={() => setActiveTab("login")}>
        Go back
      </a>
    </div>
  );
}

ForgotPassword.propTypes = {
  onClose: func,
  setActiveTab: func,
  userInfo: object,
  setUserInfo: func,
  setLoading: func,
};
